import moment from "moment";

// Financial years from accounting period start, one year each, capped at accounting period end, latest first
export function financialYears(society) {
  const years = [];
  const end = moment(society.accountingPeriodTo);
  let start = moment(society.accountingPeriodFrom);
  while (!start.isAfter(end, "day")) {
    const yearEnd = moment.min(
      start.clone().add(1, "year").subtract(1, "day"),
      end
    );
    years.push({
      startDate: start.format("YYYY-MM-DDT00:00:00"),
      endDate: yearEnd.format("YYYY-MM-DDT00:00:00"),
    });
    start = start.clone().add(1, "year");
  }
  return years.reverse();
}

export function periodLabel(period, society) {
  const label = `${moment(period.startDate).format("DD/MM/YYYY")} - ${moment(period.endDate).format("DD/MM/YYYY")}`;
  const isCurrent =
    society && moment(period.startDate).isSame(society.currentPeriodFrom, "day");
  return isCurrent ? `${label} (Current)` : label;
}
